import React from 'react';
import Waiter from "../../controls/Waiter.mjs";
import "./AddressBook.css";
import AutoIcon from "../../controls/AutoIcon.mjs";
import appLib from "../../libs/appLib.mjs";
import openLocationInNavigator from "../../controls/openLocationInNavigator.mjs";

const G = window.glob;

const parseMapUri = uri => {
	if ( typeof uri !== "string" ) return '';
	if ( uri.startsWith("http") ) return uri;
	if ( uri.match(/^[^:]*:?[0-9.]+,[0-9.]+(,[0-9]+)?$/) ) {
		const ans = uri.replace(/^[^:]*:?([0-9.]+,[0-9.]+(,[0-9]+)?)$/,"$1").split(",").map( x => parseFloat(x));
		if ( ans.length === 2 ) ans.push(19);
		return ans;
	}
}

const AddressBookEntry = class extends React.Component {
	render() {
		const d = this.props.data;
		if ( d === 'hr' ) return <hr />;
		if ( typeof d === 'string' ) return <h2>{ d }</h2>;
		// eslint-disable-next-line
		const mapuri = typeof d.map === 'string' ? parseMapUri(d.map) : (d.address ? 'https://maps.google.it/?q='+encodeURIComponent((d.address||'') + ' '+ 'Oliveto Sabino') : '');
		return (
			<div className={"AddressBookEntry"}>
				{ d.name && (
					<h3>
						{ d.link ? (
							<>
								<AutoIcon value={'link'}/>
								<a href={d.link} target="_blank" rel="noopener noreferrer">
									{d.name}
								</a>
							</>
						) : d.name
						}
					</h3>
				)}
				{d.desc && <div className={"desc"}>{d.desc}</div>}
				{ mapuri && (
					<div className={"address"}>
						<AutoIcon value={'share'}/>
						{ typeof mapuri === 'string' ? (
							<a
								href={ mapuri }
								target="ollivudmap"
								rel="noopener noreferrer"
							>
								{ d.address || G.label('Drive directions')}
							</a>
						) : (
							<a
								href={ window.location.href }
								onClick={ ()=>{ openLocationInNavigator.apply(this, mapuri) } }
							>
								{ d.address || G.label('Drive directions')}
							</a>
						)}
					</div>
				)}
				{ d.address && (!d.map) && (
					<div className={"address"}>
						{ d.address }
					</div>
				)}
				{ d.note && (
					<div className={"note"}>
						<AutoIcon value={"calendar"} />
						{ d.note }
					</div>
				)}
				{ d.ph && (
					<div className={"ph"}>
						<AutoIcon value={"phone"} />
						<a href={"tel:"+d.ph.replace(/[^0-9]/g,'') }>{ d.ph }</a>
					</div>
				)}
			</div>
		);
	}
}

const AddressBook = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('AddressBook');
		this.state = {
			list: this.parse(appLib.dataCache('directory'))
		};
		this.load = this.load.bind(this);
		this.parse = this.parse.bind(this);
	}
	componentDidMount() {
		setTimeout( this.load );
	}
	load() {
		appLib.data('directory').then( d => {
			this.setState({list: this.parse(d) });
		} ).catch( e => {
			console.error(e);
			this.setState({list: this.state.list || false });
		} );
	}
	parse(data) {
		if ( ! data ) {
			if ( this.state?.list ) {
				data = this.state.list;
			} else {
				return false;
			}
		}
		const list = [];
		let inner = [];
		data.forEach( x => {
			if ( typeof x === 'string' ) {
				if ( inner.length ) list.push(inner);
				inner = [x];
			} else {
				inner.push(x);
			}
		});
		if ( inner.length ) list.push(inner);
		return list;
	}
	render() {
		if ( typeof this.state.list === 'undefined') {
			return(
				<div className={"text-center"}>
					<Waiter />
				</div>
			);
		}
		if ( ! this.state.list ) {
			return(
				<div className={"text-center"}>
					<h2>
						<span>Errore nel caricamento - </span>
						<a href={window.location.href} onClick={this.load}>Riprova</a>
					</h2>
				</div>
			);
		}
		if ( this.state.list.length === 0 ) return (<h2>Lista vuota</h2>);
		return(
			<div className={"AddressBook"} id={this.uid}>
				{ this.state.list.map( (block,idx) => (
					<div className={"AddressBookBlock"} key={idx}>
						{ block.map((d, i) => <AddressBookEntry key={i} data={d} /> )}
					</div>
				)) }
			</div>
		);
	}
}

export default AddressBook;
